import * as fs from 'fs-extra';
import * as path from 'path';

import { convert } from './convert';

export const convertFile = async (fileName: string): Promise<void> => {
  const contents = await fs.readFile(fileName, 'utf8');
  const converted = convert(contents);
  const outputFileName = path.join(
    path.dirname(fileName),
    `${path.basename(fileName, '.js')}.ts`,
  );
  await fs.writeFile(outputFileName, converted);
};
